import { UI_STRINGS } from '../../functions/language/uistrings';
import { WeightMetric } from './weight.metric';
import { WeightUSMetric } from './weight.us-metric';

export const WeightMetricLanguageMinimalLabel = {
  [WeightMetric.Gram]: UI_STRINGS.DISPLAY_UNIT_TITLE_MINIMAL.GRAM,
  [WeightMetric.KiloGram]: UI_STRINGS.DISPLAY_UNIT_TITLE_MINIMAL.KILO_GRAM,
  [WeightMetric.Tonne]: UI_STRINGS.DISPLAY_UNIT_TITLE_MINIMAL.TONNE,
  [WeightMetric.KiloTonne]: UI_STRINGS.DISPLAY_UNIT_TITLE_MINIMAL.KILO_TONNE,
  [WeightMetric.GigaTonne]: UI_STRINGS.DISPLAY_UNIT_TITLE_MINIMAL.GIGA_TONNE,
  [WeightMetric.MegaTonne]: UI_STRINGS.DISPLAY_UNIT_TITLE_MINIMAL.MEGA_TONNE,
  // US measurement system
  [WeightUSMetric.GramUS]: UI_STRINGS.DISPLAY_UNIT_TITLE_MINIMAL.GRAM_US,
  [WeightUSMetric.KiloGramUS]: UI_STRINGS.DISPLAY_UNIT_TITLE_MINIMAL.KILO_GRAM_US,
  [WeightUSMetric.TonneUS]: UI_STRINGS.DISPLAY_UNIT_TITLE_MINIMAL.TONNE_US,
  [WeightUSMetric.KiloTonneUS]: UI_STRINGS.DISPLAY_UNIT_TITLE_MINIMAL.KILO_TONNE_US,
  [WeightUSMetric.GigaTonneUS]: UI_STRINGS.DISPLAY_UNIT_TITLE_MINIMAL.GIGA_TONNE_US,
  [WeightUSMetric.MegaTonneUS]: UI_STRINGS.DISPLAY_UNIT_TITLE_MINIMAL.MEGA_TONNE_US,
};
